export enum TicketSource {
    all = 0,
    form = 1,
    facebook = 2,
    instagram = 4,
    email = 5,
    chat = 6,
    youtube = 7,
    linkedin = 9,
    googleMyBusiness = 10,
    trustpilot = 11,
    googlePlayMarket = 12,
    appStore = 13,
    whatsApp = 14,
    tikTok = 15,
    api = 16,
}
